import { render, staticRenderFns } from "./ConfigAftersale.vue?vue&type=template&id=756da43b&scoped=true"
import script from "./ConfigAftersale.vue?vue&type=script&lang=js"
export * from "./ConfigAftersale.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "756da43b",
  null
  
)

export default component.exports